export const enum CoverageType {
    FromTv = 'from_tv',
    FromVenue = 'from_venue',
    Basic = 'basic'
}
